import React, { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { inject, observer } from 'mobx-react'
import { stripMagicLinkParamsFromUrl } from '~/utilities/buildAuthReturnUrl'

const MagicLinkHandler = observer(({ auth, isLoggedIn }) => {
  const router = useRouter()
  const hasProcessed = useRef(false)

  useEffect(() => {
    if (!router.isReady || hasProcessed.current) return

    const mlt = router.query.mlt
    const mlu = router.query.mlu
    if (!mlt || !mlu) return

    const tokenValid = /^[a-f0-9]{64}$/i.test(String(mlt))
    const userIdValid = /^[A-Za-z0-9]{10,24}$/.test(String(mlu))
    if (!tokenValid || !userIdValid) return

    const cleanedUrl = stripMagicLinkParamsFromUrl(router.asPath)

    if (isLoggedIn) {
      hasProcessed.current = true
      router.replace(cleanedUrl, undefined, { shallow: true })
      return
    }

    hasProcessed.current = true
    auth
      .magicLinkLogin(String(mlu), String(mlt))
      .then((success) => {
        if (!success) return
        router.replace(cleanedUrl, undefined, { shallow: true })
      })
      .catch((error) => {
        console.error('Error signing in a user with magic link', error)
      })
  }, [auth, isLoggedIn, router, router.isReady, router.query.mlt, router.query.mlu])

  return null
})

export default inject((all) => ({
  auth: all.store.auth,
  isLoggedIn: all.store.auth.isLoggedIn,
}))(MagicLinkHandler)
